import { useMutation } from '@hooks/reactQuery';

import { updateAlarmNoVesRules } from '@api/alarmManagement';

import { TAlarmUpdateNoVeRuleDTO } from '@interfaces/alarms/dto/alarmsDTO';

import { ALARM_UPDATE_NO_VES_RULE_ORAN } from '@constants/queryKeys';

interface IUseMutateAlarmsUpdateNoVesRulesReturn {
	updateAlarmNoVesRules: (data: TAlarmUpdateNoVeRuleDTO[]) => void;
	isLoadingUpdateAlarmNoVesRules: boolean;
}

export const useMutateAlarmsUpdateNoVesRules = (): IUseMutateAlarmsUpdateNoVesRulesReturn => {
	const {
		mutateAsync,
		isLoading,
	} = useMutation<TAlarmUpdateNoVeRuleDTO[]>({
		mutationKey: [ALARM_UPDATE_NO_VES_RULE_ORAN],
		mutationFn: updateAlarmNoVesRules,
	});

	return {
		updateAlarmNoVesRules: mutateAsync,
		isLoadingUpdateAlarmNoVesRules: isLoading,
	};
};
